import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useProductModal } from '@pages/Catalogs/providers';

import { ContentContainer } from './components/ContentContainer';

interface IProps {
  warehouse_uid: string;
}

export const ProductsModal: React.FC<IProps> = ({ warehouse_uid }) => {
  const catalogsT = useTranslation(NSKeys.catalogs);
  const commonT = useTranslation(NSKeys.common);
  const [open, setOpen] = React.useState<boolean>(false);
  const { resultProducts, onSelectChange, setResultProducts, selectedRows } = useProductModal();

  const handleApply = () => {
    setOpen(false);
    setResultProducts(selectedRows);
  };

  const handleClose = () => {
    setOpen(false);
    onSelectChange(resultProducts);
  };

  return (
    <>
      <Button
        type="primary"
        iconPlacement="end"
        icon={<EditOutlined />}
        onClick={() => {
          setOpen(true);
        }}>
        {commonT.t('selected')}: {selectedRows.length}
      </Button>
      <Modal
        width="100vw"
        style={{ top: 0, paddingBottom: 0 }}
        styles={{
          container: {
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 0,
          },
          body: {
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
          },
        }}
        title={<p>{catalogsT.t('form.productModalTitle')}</p>}
        footer={
          <Button type="primary" onClick={handleApply}>
            {commonT.t('buttonApply')}
          </Button>
        }
        open={open}
        onCancel={handleClose}>
        <ContentContainer warehouse_uid={warehouse_uid} />
      </Modal>
    </>
  );
};
